<ng-content></ng-content>
@if (load) {
  <pr-loader></pr-loader>
}
